module.exports = __webpack_public_path__ + "img/img-ac73a0a7.9887a6df.png";